export enum Position {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Center = 'center',
  Auto = 'auto',
}

export enum PositionStrategy {
  Absolute = 'absolute',
  Fixed = 'fixed',
}

export enum Arrangement {
  Inside = 'inside',
  Outside = 'outside',
  Center = 'center',
}

export enum Orientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
